/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import './src/styles/global.css'
import './src/styles/tailwind.css'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/functions'
import 'firebase/compat/database'
import React from 'react'
import AuthProvider from './src/context/auth'
import CreditsProvider from './src/context/credit'
import firebase from 'firebase/compat/app'
import { Notifications } from 'react-push-notification'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './src/stores'

const firebaseConfig = {
  apiKey: process.env.GATSBY_apiKey,
  authDomain: process.env.GATSBY_authDomain,
  projectId: process.env.GATSBY_projectId,
  storageBucket: process.env.GATSBY_storageBucket,
  messagingSenderId: process.env.GATSBY_messagingSenderId,
  appId: process.env.GATSBY_appId,
  measurementId: process.env.GATSBY_measurementId,
  databaseURL: process.env.GATSBY_databaseURL,
}

firebase.initializeApp(firebaseConfig)

export const wrapRootElement = ({ element }) => {
  return (
    <>
      <Notifications />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AuthProvider>
            <CreditsProvider>{element}</CreditsProvider>
          </AuthProvider>
        </PersistGate>
      </Provider>
    </>
  )
}

export const onRouteUpdate = ({ location }) => {
  const pathname = location.pathname
  const search = location.search || ''

  // List of authentication related pages to exclude
  const authPages = ['/signin', '/register', '/reset', '/PhoneAuth']

  if (!authPages.some(authPage => pathname.startsWith(authPage))) {
    localStorage.setItem('pathHistory', pathname + search)
  }
}
